import type { UseFormReturn } from 'react-hook-form';

import { EquiposMaterialesViewOTInstallFormTab } from '@/erp/operaciones/auditoria/instalaciones/shared/components';
import { EquipoAdicionalInstallTectAsig } from '@/erp/tecnico/orden-trabajo/shared/components/SaveOrdenTrabajo/equipos';
import { tabTextLabelSx } from '@/shared';
import { TabTextLabel } from '@/shared/components/ui';
import { CustomToggleSectionBtnOnly } from '@/shared/components/ui/Sections';
import type { Contrato } from '@/shared/interfaces';
import type { ClienteFibraSummaryFormType } from './SaveContractFibra';
import {
  ClienteFibraOTServicePart,
  ClienteFibraServicePlanTable,
} from './servicios';

export type ClienteFibraServiceFormTabProps = {
  contract: Contrato;
  form: UseFormReturn<ClienteFibraSummaryFormType>;
};

const ClienteFibraServiceFormTab: React.FC<ClienteFibraServiceFormTabProps> = ({
  contract,
  form,
}) => {
  return (
    <>
      {/* ---------------- service plan table ---------------- */}
      <ClienteFibraServicePlanTable contract={contract} />

      {/* ---------------- Equipos Adicionales Preventa - Table ---------------- */}
      <TabTextLabel
        text="EQUIPOS ADICIONALES PREVENTA"
        sx={{
          ...tabTextLabelSx,
          pb: '3px',
          pt: '54px',
          mt: '0px',
        }}
      />
      <EquipoAdicionalInstallTectAsig
        ordenTrabajo={contract.orden_trabajo_data!}
        isOnlyView
      />

      {/* ---------------- Equipos asignados OT - Table ---------------- */}
      <CustomToggleSectionBtnOnly
        btnText="Ver Equipos Asignados"
        isFirstSection
      >
        <EquiposMaterialesViewOTInstallFormTab
          ordenTrabajo={contract.orden_trabajo_data!}
        />
      </CustomToggleSectionBtnOnly>

      {/* ---------------- OT info ---------------- */}
      <CustomToggleSectionBtnOnly btnText="Ver Detalle Instalación">
        <ClienteFibraOTServicePart contract={contract} form={form} />
      </CustomToggleSectionBtnOnly>
    </>
  );
};

export default ClienteFibraServiceFormTab;
